// src/authState.js
import { ref } from 'vue'
import firebase from './firebase' // v8形式で初期化された firebase インスタンスを使う
import store from './store' // Vuexストアをインポート

// ユーザー情報を保存するリアクティブな変数
const user = ref(null)

// 認証状態を監視する関数（v8では auth は firebase.auth()）
firebase.auth().onAuthStateChanged((firebaseUser) => {
  if (firebaseUser) {
    user.value = firebaseUser
    // storeのuserIdとmyNicknameを更新
    store.state.userId = firebaseUser.uid
    store.state.myNickname = firebaseUser.displayName || ''

    // localStorageを先に更新（新規ユーザーの場合、前のユーザーのデータを読み込まないように）
    localStorage.setItem('lastUserId', firebaseUser.uid)
    localStorage.setItem('lastNickname', firebaseUser.displayName || '')

    // ログイン時にお気に入りレイヤーと最近使用レイヤーを再読み込み
    store.dispatch('loadFavoriteLayersFromStorage')
    store.dispatch('loadRecentLayersFromStorage')
  } else {
    user.value = null
    // storeのuserIdとmyNicknameをクリア
    store.state.userId = ''
    store.state.myNickname = ''
    // セッション切れや自動ログアウト時にlastUserIdをクリア
    // これにより、次回起動時に古いuidで取得を試みることを防ぐ
    localStorage.setItem('lastUserId', '')
    localStorage.setItem('lastNickname', '')
    // 新規登録促進ダイアログの非表示フラグをリセット（ログアウト後に再表示）
    localStorage.removeItem('oh3.hideSignUpPromo')
    // ログアウト時にお気に入りと最近使用レイヤーをクリア
    store.state.favoriteLayerIds = []
    store.state.recentLayerIds = []
  }
})

export { user }

// import { ref } from "vue";
// import { auth } from "./firebase";
// import { onAuthStateChanged } from "firebase/auth";
//
// // ユーザー情報を保存するリアクティブな変数
// const user = ref(null);
// // 認証状態を監視する関数
// onAuthStateChanged(auth, (firebaseUser) => {
//     if (firebaseUser) {
//         user.value = firebaseUser; // ユーザー情報をセット
//     } else {
//         user.value = null; // ログアウト時
//     }
// });
//
// export { user };
